<template>
  <div>
    <v-toolbar
      flat
      color="white"
    >
      <v-text-field
        v-model="search"
        prepend-icon="search"
        label="Search"
        single-line
        hide-details
      ></v-text-field>
      <v-spacer></v-spacer>
      <v-dialog
        v-model="dialog"
        max-width="600px"
      >
        <v-btn
          slot="activator"
          icon
        >
          <v-icon>add_circle_outline</v-icon>
        </v-btn>
        <v-card>
          <v-toolbar
            card
            dense
            color="transparent"
          >

            <v-btn
              icon
              @click.native="close"
            >
              <v-icon>reply</v-icon>
            </v-btn>

            <!-- <v-toolbar-title><h4>Details</h4></v-toolbar-title> -->
            <v-btn
              icon
              @click.native="saveAndClose"
            >
              <v-icon>library_add</v-icon>
            </v-btn>

            <v-btn
              icon
              @click.native="save"
            >
              <v-icon>save</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="add"
            >
              <v-icon>add</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="deleterow"
            >
              <v-icon>delete</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="first"
            >
              <v-icon>first_page</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="next"
            >
              <v-icon>keyboard_arrow_left</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="previous"
            >
              <v-icon>keyboard_arrow_right</v-icon>
            </v-btn>
            <v-btn
              icon
              @click.native="last"
            >
              <v-icon>last_page</v-icon>
            </v-btn>
            <v-menu
              bottom
              left
            >
              <v-btn
                slot="activator"
                icon
              >
                <v-icon>more_vert</v-icon>
              </v-btn>
              <v-list>
                <v-list-tile
                  v-for="(item, i) in items"
                  :key="i"
                  click
                >
                  <v-list-tile-title>{{ item.title }}</v-list-tile-title>
                </v-list-tile>
              </v-list>
            </v-menu>
            <!-- <v-spacer></v-spacer> <v-btn color="primary" outline>Post</v-btn> -->
          </v-toolbar>
          <v-card-title>
            <span class="headline">{{ formTitle }}</span>
          </v-card-title>

          <v-card-text>
            <v-form
              v-model="editedItem.valid"
              ref="form"
              lazy-validation
            >
              <v-container grid-list-md>
                <v-layout wrap>
                  <!-- <v-flex
                    xs12
                    sm12
                  >
                    <v-autocomplete                     
                      hint="Atleast 3 Characters required"                      
                      :loading="loader"
                      chips
                      cache-items                      
                      flat
                      placeholder="Select only suggested Document"
                      prepend-icon="assistant"
                      :items='dropDocumentItems'
                      v-model="editedItem.documentID"
                      label="Document"
                      color="blue"
                      item-text="fileName"
                      item-value="documentID"
                    >
                    </v-autocomplete>
                  </v-flex> -->
                  <!-- <v-flex
                    xs12
                    sm12
                  >
                    <v-text-field
                      v-model="editedItem.permissionName"
                      label="Permission Name"
                      :rules="editedItem.nameRules"
                      required
                      prepend-icon="select_all"
                    ></v-text-field>
                  </v-flex> -->
                  <!-- <v-flex
                    xs12
                    sm12
                  >
                    <v-text-field
                      v-model="editedItem.permissionCode"
                      label="Permission Code"
                      prepend-icon="description"
                    >
                      <div slot="label">
                        Permission Code
                      </div>
                    </v-text-field>
                  </v-flex> -->
                  <!-- <v-flex
                    xs12
                    sm12
                  >
                    <v-text-field
                      v-model="editedItem.permissionOrder"
                      label="Permission Order"
                      prepend-icon="description"
                    >
                      <div slot="label">
                        Permission Order
                      </div>
                    </v-text-field>
                  </v-flex> -->
                  <v-flex
                    sm4
                    lg4
                  >
                    <v-checkbox
                      v-model="editedItem.isRead"
                      label="Read"
                      value="True"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex
                    sm4
                    lg4
                  >
                    <v-checkbox
                      v-model="editedItem.isCreateFolder"
                      label="Create Folder"
                      value="True"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex
                    sm4
                    lg4
                  >
                    <v-checkbox
                      v-model="editedItem.isCreateDocument"
                      label="Create Document"
                      value="True"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex
                    sm4
                    lg4
                  >
                    <v-checkbox
                      v-model="editedItem.isSetAlert"
                      label="Set Alert"
                      value="True"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex
                    sm4
                    lg4
                  >
                    <v-checkbox
                      v-model="editedItem.isEditIndex"
                      label="Edit Index"
                      value="True"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex
                    sm4
                    lg4
                  >
                    <v-checkbox
                      v-model="editedItem.isRename"
                      label="Rename"
                      value="True"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex
                    sm4
                    lg4
                  >
                    <v-checkbox
                      v-model="editedItem.isUpdateDocument"
                      label="Update Document"
                      value="True"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex
                    sm4
                    lg4
                  >
                    <v-checkbox
                      v-model="editedItem.isCopy"
                      label="Copy"
                      value="True"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex
                    sm4
                    lg4
                  >
                    <v-checkbox
                      v-model="editedItem.isMove"
                      label="Move"
                      value="True"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex
                    sm4
                    lg4
                  >
                    <v-checkbox
                      v-model="editedItem.isDelete"
                      label="Delete"
                      value="True"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex
                    sm4
                    lg4
                  >
                    <v-checkbox
                      v-model="editedItem.isRelationship"
                      label="Relationship"
                      value="True"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex
                    sm4
                    lg4
                  >
                    <v-checkbox
                      v-model="editedItem.isListVersion"
                      label="List Version"
                      value="True"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex
                    sm4
                    lg4
                  >
                    <v-checkbox
                      v-model="editedItem.isInvitation"
                      label="Invitation"
                      value="True"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex
                    sm4
                    lg4
                  >
                    <v-checkbox
                      v-model="editedItem.isSendEmail"
                      label="Send Email"
                      value="True"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex
                    sm4
                    lg4
                  >
                    <v-checkbox
                      v-model="editedItem.isDiscussion"
                      label="Discussion"
                      value="True"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex
                    sm4
                    lg4
                  >
                    <v-checkbox
                      v-model="editedItem.isAccessControl"
                      label="Access Control"
                      value="True"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex
                    sm4
                    lg4
                  >
                    <v-checkbox
                      v-model="editedItem.isAuditTrail"
                      label="Audit Trail"
                      value="True"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex
                    sm4
                    lg4
                  >
                    <v-checkbox
                      v-model="editedItem.isRequired"
                      label="Required"
                      value="True"
                    ></v-checkbox>
                  </v-flex>
                  <v-flex
                    xs12
                    sm6
                    md4
                  >
                    <v-autocomplete
                      label="Status"
                      prepend-icon="notes"
                      v-model="editedItem.statusCodeID"
                      :items="statusOptions"
                    >
                    </v-autocomplete>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-form>
          </v-card-text>
          
          <delete-confirmation-dialog
            ref="formdeleteConfirmationDialog"
            heading="Are You Sure You Want To Delete?"
            message="Are You Sure You Want To Delete This Item Permanently?"
            @onConfirm="formDeleteItem"
          >
          </delete-confirmation-dialog>

        </v-card>
      </v-dialog>
    </v-toolbar>
    <app-section-loader :status="loader"></app-section-loader>
    <v-data-table
      :headers="headers"
      :items="gridItems"
      :search="search"
      class="elevation-1"
      default-sort="documentPermissionID:desc"
    >
      <template
        slot="items"
        slot-scope="props"
      >

        <!-- <td>{{ props.item.permissionName }}</td>
        <td class="text-xs-left">{{ props.item.permissionCode }}</td>
        <td class="text-xs-left">{{ props.item.permissionOrder }}</td> -->
        <td class="text-xs-left">{{ props.item.statusCodeID }}</td>
        <td class="text-xs-left">{{ props.item.addedByUser }}</td>
        <td class="text-xs-left">{{ props.item.modifiedByUser }}</td>
        <td class="text-xs-left">{{ props.item.modifiedDate | formatDate}}</td>

        <td class="justify-center layout px-0">
          <v-icon
            small
            class="mr-2"
            @click="editItem(props.item)"
          >
            edit
          </v-icon>
          <v-icon
            small
            @click="onDeleteItem(props.item)"
          >
            delete
          </v-icon>
        </td>
      </template>
      <template slot="no-data">
        <v-btn
          color="primary"
          outline
          @click="initialize"
        > Record not exist.Refresh again in while time.</v-btn>
      </template>
    </v-data-table>
    <v-snackbar
      :top="y === 'top'"
      :timeout="timeout"
      v-model="snackbar"
    >
      {{ snackbarMessage }}
    </v-snackbar>
    <delete-confirmation-dialog
      ref="deleteConfirmationDialog"
      heading="Are You Sure You Want To Delete?"
      message="Are You Sure You Want To Delete This Item Permanently?"
      @onConfirm="deleteItem"
    >
    </delete-confirmation-dialog>
  </div>
</template>
<script>
import { getAccessRights, getDocuments, getAccessRight, createAccessRight, updateAccessRight, deleteAccessRight } from '@/api/accessRights';
import GlobalMessage from '@/constant'
export default {
  data: () => ({
    dialog: false,
    loader: false,
    search: '',
    dropDocumentItems: [],
    statusOptions: [
      { text: 'Active', value: 1 },
      { text: 'InActive', value: 2 }
    ],
    snackbar: false,
    snackbarMessage: '',
    timeout: 2000,
    y: 'top',
    headers: [
      // { text: 'Permission Name', value: 'permissionName', align: 'left' },
      // { text: 'Permission Code', value: 'permissionCode', align: 'left' },
      // { text: 'Permission Order', value: 'permissionOrder', align: 'left' },
      { text: 'Status', value: 'statusCode', align: 'left' },
      { text: 'Added By', value: 'addedByUserId', align: 'left' },
      { text: 'Modified By', value: 'modifiedByUserId', align: 'left' },
      { text: 'Modified Date', value: 'modifiedDate', align: 'left' },
      { text: 'Actions', value: 'name', sortable: false, align: 'left' }
    ],
    gridItems: [],
    editedIndex: -1,
    selectedItem: null,
    editedItem: {
      valid: false,
      documentPermissionID: -1,
      documentID: null,
      documentName: null,
      permissionName: '',
      nameRules: [v => !!v || 'Name is required'],
      permissionCode: '',
      permissionOrder: '',
      isRead: 'false',
      isCreateFolder: 'false',
      isCreateDocument: 'false',
      isSetAlert: 'false',
      isEditIndex: 'false',
      isRename: 'false',
      isUpdateDocument: 'false',
      isCopy: 'false',
      isMove: 'false',
      isDelete: 'false',
      isRelationship: 'false',
      isListVersion: 'false',
      isInvitation: 'false',
      isSendEmail: 'false',
      isDiscussion: 'false',
      isAccessControl: 'false',
      isAuditTrail: 'false',
      isRequired: 'false',
      addedByUserId: null,
      addedDate: new Date(),
      statusCodeID: 1,
      statusCode: 'Active',
      modifiedByUserId: null,
      modifiedDate: new Date()
    },
    defaultItem: {
      valid: false,
      documentPermissionID: -1,
      documentID: null,
      documentName: null,
      permissionName: '',
      nameRules: [v => !!v || 'Name is required'],
      permissionCode: '',
      permissionOrder: '',
      isRead: 'false',
      isCreateFolder: 'false',
      isCreateDocument: 'false',
      isSetAlert: 'false',
      isEditIndex: 'false',
      isRename: 'false',
      isUpdateDocument: 'false',
      isCopy: 'false',
      isMove: 'false',
      isDelete: 'false',
      isRelationship: 'false',
      isListVersion: 'false',
      isInvitation: 'false',
      isSendEmail: 'false',
      isDiscussion: 'false',
      isAccessControl: 'false',
      isAuditTrail: 'false',
      isRequired: 'false',
      addedByUserId: null,
      addedDate: new Date(),
      statusCodeID: 1,
      statusCode: 'Active',
      modifiedByUserId: null,
      modifiedDate: new Date()
    },
    searchItem: { action: '', Id: null, searchString: 'searchString', },
    items: [
      { title: 'Clear Items' },
      { title: 'Post' },
      { title: 'Delete' },
      { title: 'Print' }
    ],
  }),

  computed: {
    formTitle () {
      return this.editedIndex === -1 ? 'Add Access Right' : 'Edit Access Right';
    }
  },

  watch: {
    dialog (val) {
      val || this.close();
    }
  },

  created () {
    this.initialize();
  },

  methods: {
    initialize () {
      this.loader = true;
      getDocuments('')
        .then(response1 => {
          this.dropDocumentItems = response1.data;
          this.loader = false;
          //this.total = response.data.length;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
      getAccessRights('')
        .then(response => {
          this.gridItems = response.data;
          this.loader = false;
          //this.total = response.data.length;
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    editItem (item) {
      this.editedIndex = this.gridItems.indexOf(item);
      this.editedItem = Object.assign({}, item);

      this.dialog = true;
    },
    onDeleteItem (item) {
      this.$refs.deleteConfirmationDialog.openDialog();
      this.selectedItem = item;
    },
    deleteItem () {
      this.$refs.deleteConfirmationDialog.close();
      this.loader = true;
      let index = this.gridItems.indexOf(this.selectedItem);
      deleteAccessRight(this.selectedItem)
        .then(() => {
          this.loader = false;
          this.selectedItem = null;
          this.gridItems.splice(index, 1);
          window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.DELETE);
        })
        .catch(error => {
          this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    close () {
      this.dialog = false;
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    saveAndClose () {
      this.save();
      this.close();
    },
    toolfunction () {

      getAccessRight(this.searchItem)
        .then(response => {

          if (response.data.documentPermissionID != null) {

            this.editedItem = response.data;
            let index = this.gridItems.map(item => item.documentPermissionID).indexOf(response.data.documentPermissionID)
            this.editedIndex = index;

          }
          else {
            window.getApp.$emit('APP_API_SUCCESS', 'No more record to view');
          }

        })
        .catch(error => {
          // this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    first () {
      this.searchItem.action = 'First';
      this.searchItem.Id = this.editedItem.documentPermissionID;
      // this.selectedItem.searchString = 'first';
      this.toolfunction();
    },
    last () {
      this.searchItem.action = 'Last';
      this.searchItem.Id = this.editedItem.documentPermissionID;
      //this.selectedItem.searchString = 'last';

      this.toolfunction();
    },
    previous () {
      this.searchItem.action = 'Previous';
      this.searchItem.Id = this.editedItem.documentPermissionID;
      //this.selectedItem.searchString = 'previous';
      this.toolfunction();
    },
    next () {
      this.searchItem.action = 'Next';
      this.searchItem.Id = this.editedItem.documentPermissionID;
      // this.selectedItem.searchString = 'next';
      this.toolfunction();
    },
    add () {

      this.editedItem.valid = false;
      this.editedItem.documentPermissionID = -1;
      this.editedItem.documentID = getDocuments.documentID;
      this.editedItem.documentName = getDocuments.documentName;
      this.editedItem.permissionName = '';
      this.editedItem.nameRules = [v => !!v || 'Name is required'];
      this.editedItem.permissionCode = '';
      this.editedItem.permissionOrder = '';
      this.editedItem.addedByUserId = this.$store.state.auth.userId;
      this.editedItem.addedDate = new Date();
      this.editedItem.statusCodeID = 1;
      this.editedItem.statusCode = 'Active';
      this.editedItem.modifiedByUserId = this.$store.state.auth.userId;
      this.editedItem.modifiedDate = new Date();
      this.editedIndex = -1;
    },
    deleterow () {
      this.$refs.formdeleteConfirmationDialog.openDialog();
    },
    formDeleteItem () {
      this.$refs.formdeleteConfirmationDialog.close();
      // this.loader = true;
      let index = this.editedIndex;
      console.log(this.editedItem);
      deleteAccessRight(this.editedItem.documentPermissionID)
        .then(() => {
          //this.loader = false;
          //this.editedItem = null;
          this.add();
          this.gridItems.splice(index, 1);
          window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.DELETE);
        })
        .catch(error => {
          //this.loader = false;
          window.getApp.$emit('APP_API_ERROR', error);
        });
    },
    close () {
      this.dialog = false;
      this.initialize();
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem);
        this.editedIndex = -1;
      }, 300);
    },
    save () {
      if (this.$refs.form.validate()) {
        this.loader = true;
        let index = this.editedIndex;
        if (this.editedIndex > -1) {
          Object.assign(this.gridItems[this.editedIndex], this.editedItem);
          this.editedItem.modifiedByUserId = this.$store.state.auth.userId;
          this.editedItem.modifiedDate = new Date();
          this.editedItem.addedByUserId = this.$store.state.auth.userId;
          this.editedItem.addedDate = new Date();
          updateAccessRight(this.editedItem)
            .then(response => {
              Object.assign(this.gridItems[index], response.data);
              this.loader = false;
              window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.UPDATE);
            })
            .catch(error => {
              this.loader = false;
              window.getApp.$emit('APP_API_ERROR', error);
            });
        } else {
          this.editedItem.documentPermissionID = parseInt(Math.random() * 100) + 1024; // mock a id
          this.editedItem.addedByUserId = this.$store.state.auth.userId;
          this.editedItem.addedDate = new Date();
          this.editedItem.statusCodeID = 1;
          createAccessRight(this.editedItem)
            .then(response => {
              this.gridItems.push(response.data);
              this.loader = false;
              this.editedItem = response.data;
              let index = this.gridItems.map(item => item.documentPermissionID).indexOf(response.data.documentPermissionID)
              this.editedIndex = index;
              window.getApp.$emit('APP_API_SUCCESS', GlobalMessage.SAVE);
            })
            .catch(error => {
              this.loader = false;
              window.getApp.$emit('APP_API_ERROR', error);
            });
        }
        //this.close();
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// src/pages/document/AccessRights.vue